import * as fromDatatype from '../datatype-library/index';

export interface bl_applet_client_side_perm_dfn_RowInterface{
    guid: fromDatatype.GuidDataFieldInterface;
    namespace: fromDatatype.NamespaceDataFieldInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    perm_type: fromDatatype.VarcharDatatypeInterface;
    perm_code: fromDatatype.VarcharDatatypeInterface;
    perm_name: fromDatatype.TextDatatypeInterface;
    perm_description: fromDatatype.TextDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
}

export class bl_applet_client_side_perm_dfn_RowClass implements bl_applet_client_side_perm_dfn_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    namespace: fromDatatype.NamespaceDataFieldInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    perm_type: fromDatatype.VarcharDatatypeInterface;
    perm_code: fromDatatype.VarcharDatatypeInterface;
    perm_name: fromDatatype.TextDatatypeInterface;
    perm_description: fromDatatype.TextDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
}